export default __webpack_public_path__ + "static/media/darkPdfIcon.9826d0b0.svg";